import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-92306074"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "lecture-cover"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 0,
  class: "lecture-type"
};
const _hoisted_5 = {
  class: "lecture-info"
};
const _hoisted_6 = {
  class: "lecture-title"
};
const _hoisted_7 = {
  class: "lecture-teacher"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "teacher-text"
}, "主讲人：", -1));

const _hoisted_9 = {
  key: 0,
  class: "teacher-list"
};
const _hoisted_10 = {
  class: "teacher-icon-list"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "teacher-name"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lecture-detail-link"
}, [/*#__PURE__*/_createElementVNode("span", null, "查看详情 >")], -1));

import { getUrlParams } from '@/plugins/utils';
export default {
  props: {
    finishLecture: Object,
    index: Number
  },

  setup(__props) {
    const props = __props;
    const $baseUrl = inject('$baseUrl');
    const menuInfo = reactive({
      menuId: getUrlParams('menuId'),
      menuName: getUrlParams('name')
    });
    const defaultCover = computed(() => {
      if (props.finishLecture.type == 1) {
        return props.index < 2 ? `lecture_online${props.index + 1}` : `lecture_online${props.index % 2 + 1}`;
      } else {
        return props.index < 2 ? `lecture_offline${props.index + 1}` : `lecture_offline${props.index % 2 + 1}`;
      }
    }); // 教师显示

    const formatTeacher = () => {
      const {
        teacher_name,
        school_name,
        job_title,
        college_name
      } = props.finishLecture.teacherDtoList[0];
      const length = props.finishLecture.teacherDtoList.length;

      if (length > 1) {
        return teacher_name + `等${length}名老师`;
      } else {
        return teacher_name + (!(school_name && college_name && job_title) ? '' : '-' + (school_name || '') + (college_name || '') + (job_title || ''));
      }
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("a", {
        href: `${_unref($baseUrl)}/lectureDetail.html?menuId=${_unref(menuInfo).menuId}&name=${_unref(menuInfo).menuName}&id=${__props.finishLecture.id}`,
        class: "lecture-card"
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: __props.finishLecture.live_cover_url || require(`@/assets/images/lecture/${_unref(defaultCover)}.png`),
        alt: "",
        class: "lecture-img"
      }, null, 8, _hoisted_3), __props.finishLecture.classify_name ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.finishLecture.classify_name), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(__props.finishLecture.live_name), 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, __props.finishLecture.teacherDtoList && __props.finishLecture.teacherDtoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.finishLecture.teacherDtoList, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("img", {
          src: item.file_url || require('@/assets/images/common/teacher_icon.png'),
          alt: "",
          class: "teacher-icon",
          key: index
        }, null, 8, _hoisted_11)), [[_vShow, index < 3]]);
      }), 128))]), _createElementVNode("span", _hoisted_12, _toDisplayString(formatTeacher()), 1)])) : _createCommentVNode("", true)]), _hoisted_13], 8, _hoisted_1);
    };
  }

};